import { Injectable } from '@angular/core';
import { StorageService } from './storage-service.model';

@Injectable()
export class LocalStorageService implements StorageService {
  public set<T>(key: string, value: T | string): void {
    const item: string = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, item);
  }

  public get(key: string): string | null {
    const item: string | null = localStorage.getItem(key);
    if (item) {
      return item;
    }

    return null;
  }

  public getParsed<T extends object>(key: string): T | null {
    const item: string | null = localStorage.getItem(key);
    if (item) {
      try {
        return JSON.parse(item);
      } catch {
        return null;
      }
    }

    return null;
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
  }
}
